import { createEffect, ofType } from "@ngrx/effects";
import { EffectMetadata } from "@ngrx/effects/src/models";
import { ActionCreator } from "@ngrx/store";
import { tap } from "rxjs/operators";
import { NgrxActions } from "../decorators.module";
import { addEffectMetadataEntry, DEFAULT_EFFECT_CONFIG, EffectPropertyKey } from "../utils/helpers";

export interface IDoWhenActionConfig {
  actions: ActionCreator[]
}

export function DoWhenActionEffect(config: IDoWhenActionConfig) {
  return function <T extends Object, K extends EffectPropertyKey<T>>(
    target: T,
    propertyKey: K,
    descriptor: PropertyDescriptor
  ) {

    const originalMethod = descriptor.value as Function;
    if (typeof originalMethod !== 'function') {
      throw new TypeError(
        `Unexpected type ${typeof originalMethod} of property ${propertyKey}, ` +
        `expected 'function'`
      );
    }

    const effectKey = `${propertyKey}_key_$` as K

    const metadata: EffectMetadata<T> = {
      ...DEFAULT_EFFECT_CONFIG, ...{ dispatch: false },
      propertyName: effectKey,
    };


    let efunc: any;
    Object.defineProperty(target, effectKey, {
      get() {

        const { actions$ } = NgrxActions;

        if (actions$ === null) {
          throw new Error(`${NgrxActions.name} not connected to store!, Please ensure you are injecting NgrxHelperModule`);
        }

        const callback = originalMethod.bind(this);
        const effect = () => {
          return createEffect(
            () => actions$.pipe(
              ofType(...[...config.actions]),
              tap(p => {
                if (p) {
                  callback(p);
                  return;
                }
                callback(null);
              })
            ), { dispatch: false }
          );
        }

        if (!efunc) {
          efunc = effect();
        }
        return efunc;
      },
      set: () => { },
    });


    addEffectMetadataEntry<T>(target, metadata);


  }

}
